import axios from 'axios';
import { APIv1Endpoint } from '../endpoints';

const fetchRestaurantConcept = async (restaurantId) => {
    try {
        const response = await axios.get(`${APIv1Endpoint}restaurant/concept/${restaurantId}`);
        return {
            name: response.data.restaurant_concept.name,
            logo1: response.data.restaurant_concept.logo1,
            logo2: response.data.restaurant_concept.logo2,
            color1: response.data.restaurant_concept.color1,
            color2: response.data.restaurant_concept.color2,
        };
    } catch (error) {
        console.error("Error fetching restaurant concept:", error);
        return null;
    }
}

export default fetchRestaurantConcept;
